<template>
    <a
        :href="adminHref"
        class="admin-link"
    >
        <al-button
            size="small"
            variant="primary"
            state="default"
        >
            <al-icon icon="settings" />
            Dashboard Administration
        </al-button>
    </a>
</template>

<script setup lang="ts">
import { useLink } from 'vue-router';

// NOTE: using vue-router to navigate directly breaks the filter bar. This gets the link from the router
// so we can use it in a regular <a> tag and rely on browser navigation instead.
const { href: adminHref } = useLink({ to: { name: 'OperationsAdministration' } });
</script>

<style scoped lang="scss">
.admin-link {
    display: flex;
    justify-content: flex-end;
    justify-self: flex-end;
    align-self: center;
    margin-left: auto;
}

.info-box-wrapper .admin-link {
    margin-top: 1rem;
}
</style>
